import { render } from "./MobileTypeHelper.vue?vue&type=template&id=64e57a4a&ts=true"
import script from "./MobileTypeHelper.vue?vue&type=script&lang=ts"
export * from "./MobileTypeHelper.vue?vue&type=script&lang=ts"

import "./MobileTypeHelper.vue?vue&type=style&index=0&id=64e57a4a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__